export enum InputType {
    TEXT = "text",
    NUMBER = "number",
    PASSWORD = "password",
    RADIO = "radio",
    DROPDOWN = "dropdown",
    FILE = "file",
    DATE = "date",
    INFO_TEXT = "info_text",
}
export interface ICurrentStyles {
    containerStyle: object;
    errorStyle: object;
    inputStyle: any;
}

export function getModifiedStyles(currentStyles, customStyles) {
    if (customStyles.hasOwnProperty("handleContainerStyle")) {
        currentStyles.handleContainerStyle = customStyles.handleContainerStyle;
    }
    if (customStyles.hasOwnProperty("inputStyle")) {
        if (customStyles.inputStyle.hasOwnProperty("handleTextFieldStyle")) {
            currentStyles.inputStyle.handleTextFieldStyle = customStyles.inputStyle.handleTextFieldStyle;
        }
        if (customStyles.inputStyle.hasOwnProperty("handleDropdownStyle")) {
            currentStyles.inputStyle.handleDropdownStyle = customStyles.inputStyle.handleDropdownStyle;
        }
        if (customStyles.inputStyle.hasOwnProperty("handleRadioStyle")) {
            currentStyles.inputStyle.handleRadioStyle = customStyles.inputStyle.handleRadioStyle;
        }
        if (customStyles.inputStyle.hasOwnProperty("handleUploadDocStyle")) {
            currentStyles.inputStyle.handleUploadDocStyle = customStyles.inputStyle.handleUploadDocStyle;
        }
        if (customStyles.inputStyle.hasOwnProperty("handleDateStyle")) {
            currentStyles.inputStyle.handleDateStyle = customStyles.inputStyle.handleDateStyle;
        }
    }
    if (customStyles.hasOwnProperty("handleErrorStyle")) {
        currentStyles.handleErrorStyle = customStyles.handleErrorStyle;
    }
    if (customStyles.hasOwnProperty("headerStyle")) {
        currentStyles.headerStyle = customStyles.headerStyle;
    }
    if (customStyles.hasOwnProperty("submitButtonStyle")) {
        currentStyles.submitButtonStyle = customStyles.submitButtonStyle;
    }
    return currentStyles;
}

export function getDefaultStyles() {
    return {
        handleContainerStyle: (val) => {
            return {
                padding: ".375rem .75rem",
                margin: "3px",
            };
        },
        submitButtonStyle: {
            color: "#000000",
        },
        headerStyle: {
            color: "#000000",
        },
        inputStyle: {
            handleTextFieldStyle: (hasError) => {
                return {
                    borderRadius: "3px",
                    color: "#495057",
                    backgroundColor: "#f9f9f9",
                    border: `1px solid ${hasError ? "red" : "#e8eaec"}`,
                    padding: ".375rem .75rem",
                    width: "100%",
                };
            },
            handleDateStyle: (hasError) => {
                return {
                    borderRadius: "3px",
                    color: "#495057",
                    backgroundColor: "#f9f9f9",
                    border: `1px solid ${hasError ? "red" : "#e8eaec"}`,
                    padding: ".375rem .75rem",
                    width: "100%",
                };
            },
            handleDropdownStyle: (hasError) => {
                return {
                    borderRadius: "3px",
                    color: "#495057",
                    backgroundColor: "#f9f9f9",
                    border: `1px solid ${hasError ? "red" : "#e8eaec"}`,
                    padding: ".375rem .75rem",
                    width: "100%",
                };
            },
            handleRadioStyle: (hasError) => {
                return {
                    background: "#fff",
                    border: "1px solid #a5a5a5",
                    margin: "2px",
                    minWidth: "80px",
                    float: "left",
                    color: "#a5a5a5",
                    borderRadius: "3px",
                    onSelect: {
                      background: "#F5821F",
                      border: "1px solid #F5821F",
                      color: "#fff",
                    },
                };
            },
            handleUploadDocStyle: (hasError) => {
                return {
                    borderRadius: "3px",
                    color: "#495057",
                    backgroundColor: "#f9f9f9",
                    border: `1px solid ${hasError ? "red" : "#e8eaec"}`,
                    padding: ".375rem .75rem",
                    width: "100%",

                };
            },
        },
        handleErrorStyle: (hasError) => {
            return {
                color: "red",
                font: "12px",
            };
        },
    };
}
